import { removeAllLocalItem, setOption } from '@rentspree/cookie'

import { cookieOption } from 'constant'
import env from 'env'

import { removeAllLocalStorageItems } from './local-storage'

export const removeAccessToken = () => {
  if (typeof window === 'undefined') return
  setOption(cookieOption(env.DOMAIN_NAME ?? 'localhost'))
  removeAllLocalItem('rentspree')
  removeAllLocalStorageItems()
}
